module.exports = __webpack_public_path__ + "static/media/play.88a8ff55.svg";